import { locale, t } from "../MainApp";
import Title from "antd/lib/typography/Title";
import { ESearchMode, GuestPersonAutocomplete } from "../sharedcomponents/GuestPersonAutocomplete";
import { Divider } from "antd";

type GuestListProps = {
    minGuests: number;
    maxGuests: number;

    guests: string[];

    onAddGuest: () => void;
    onRemoveGuest: (seatNo: number) => void;
    onChangeGuestName: (seatNo: number, name: string) => void;


    locale: locale;

    tableName: string;
};

export function GuestsList(props: GuestListProps) {

    

    function buildGuestName(seatNo: number) {
        return t(props.locale, "wholehallplaces").replace("{0}", (seatNo + 1).toString()).replace("{1}", props.maxGuests.toString());
    }

    function renderGuestField(seatNo: number) {
        return <>
            <GuestPersonAutocomplete 
                onBuildGuestName={() => buildGuestName(seatNo)}
                onChangeGuestName={(newName) => props.onChangeGuestName(seatNo, newName)}
                value={props.guests[seatNo]}
                style={{ width: '100%' }}
                searchMode={ESearchMode.WholeHallReservation}
            />
        </>;
    }

    function renderTableName() {
        return <Title level={5} style={{ width: '100%', textAlign: 'center' }}>{props.tableName}</Title>;
    }

    function buildGuestsFields() {
        let guestFields = [];

        for (let idx = 0; idx < props.guests.length; ++idx) {
            guestFields.push(renderGuestField(idx));
        }

        return guestFields;
    }

    return (
        <>
            {renderTableName()}
            <br />
            {buildGuestsFields()}
        </>
    );
}

